import $ from 'jquery';

(function($) {
    'use strict';
    $._ipsInfiniteScroll = {
        defaults: {
            debug: false,
            noresults: false,
            page: 1,
            padding: 600,
            load: function(page){}
        }
    };
    var ipsInfiniteScroll = function ($e, options) {
        var _data = $e.data('_ipsInfiniteScroll') || {},
            _userOptions = (typeof options === 'function') ? { callback: options } : options,
            _options = $.extend({}, $._ipsInfiniteScroll.defaults, _userOptions, _data || {})
        ;

        var _bindToScroll = function(){
            if ($(window).scrollTop() + $(window).height() <= $(document).height() - _options.padding) {
                return;
            }
            if($e.data("noresults") || $e.data("waiting")) {
            //    if($e.data("waiting")) console.log('%c==== Waiting...','color:green');
                return;
            }
//                    console.log(($(window).scrollTop() + $(window).height()));
//                    console.log(($(document).height() - _options.padding));
            $e.data("waiting", true);

            setTimeout(function() {
                try {
                //    console.log('%c==== Loading...','color:green');
                    _options.load($e.data("page"), $e);
                }
                catch(e) {
                //    console.log('%c==== Loading error...','color:green');
                    logger.error("Load results error");
                }
            }, 30);
        };

        $e.data('_ipsInfiniteScroll', $.extend({}, _data, {initialized: true}));
        $e.data("noresults", _options.noresults);
        $e.data('page',_options.page);
        $e.data('waiting',false);
        $(window).scroll(_bindToScroll);

        return $e;
    };

    $.fn.ipsInfiniteScroll = function(m) {
    //    console.log('%c==== binding...','color:green');
    //    console.log(m);
    //    console.log($(this));
        return this.each(function() {
            var $this = $(this),
                data = $this.data('_ipsInfiniteScroll');

            // Instantiate object on this element if it hasn't been already
            if (data && data.initialized) {
                return;
            }
            ipsInfiniteScroll($this, m);
        });
    };
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/jquery.ips.infinitescroll.js
// module id = 351
// module chunks = 4